<template>
    <ExtendedLayout
        :project="project"
        currentTab="properties"
    >

        <Panel>

            <Heading type="h2" class="flex items-center gap-2">
                <span>{{ __('admin::properties.properties') }}</span>
                <InertiaLink :href="$route('admin::projects.properties.create', { project: project.id })" class="inline-flex items-center p-1 border border-transparent rounded-full shadow-sm text-white bg-primary hover:bg-primary-hover focus:outline-none">
                    <PlusIcon class="h-4 w-4 text-white" />
                </InertiaLink>
            </Heading>

            <div
                class="text-gray-500 mt-5"
                v-if="! paginator.data.length"
            >
                {{ __('admin::general.no_models_added', { model: __('admin::properties.properties').toLowerCase() }) }}
                <InertiaLink :href="$route('admin::projects.properties.create', { project: project.id })" class="inline-flex items-center gap-1 text-primary hover:text-primary-hover">
                    {{ __('admin::general.add_model', { model: __('admin::properties.property') }) }}
                    <PlusIcon class="inline-block w-3 h-3" />
                </InertiaLink>
            </div>

            <div class="flex flex-col mt-5" v-else>
                <div class="-mt-2 -mb-8 overflow-x-auto -mx-4 sm:-mx-6">
                    <div class="py-2 align-middle inline-block min-w-full">
                        <div class="shadow overflow-hidden border-t border-gray-200" :class="[paginator?.last_page > 1 ? '' : 'rounded-b-lg']">
                            <table class="min-w-full divide-y divide-gray-200 table--index">
                                <thead class="bg-gray-50">
                                <tr>
                                    <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">{{ __('admin::labels.id') }}</th>
                                    <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">{{ __('admin::labels.external_id') }}</th>
                                    <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">{{ __('admin::labels.feed') }}</th>
                                    <th scope="col" class="relative px-6 py-3 whitespace-nowrap w-1">
                                        <span class="sr-only">{{ __('forms::actions.actions') }}</span>
                                    </th>
                                </tr>
                                </thead>
                                <tbody class="bg-white divide-y divide-gray-200">

                                    <tr v-for="property in paginator.data" :key="property.id">
                                        <td>{{ property.id }}</td>
                                        <td>{{ property.external_id }}</td>
                                        <td>{{ feedOptions[property.project_feed_id] || '—' }}</td>
                                        <td>
                                            <TableButton
                                                variant="edit"
                                                :href="$route('admin::projects.properties.edit', { project: project.id, property: property.id })"
                                            />
                                            <TableButton
                                                variant="destroy"
                                                @delete="deleting = $route('admin::projects.properties.destroy', { project: project.id, property: property.id })"
                                            />
                                        </td>
                                    </tr>

                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>

            <Pagination v-if="paginator" :paginator="paginator" class="mt-12" />

        </Panel>

        <DeleteDialog
            :title="__('admin::general.delete_model', { model: __('admin::properties.property') })"
            :url="deleting"
            v-if="deleting"
            @closed="deleting = null"
        />

    </ExtendedLayout>
</template>

<script>
import ExtendedLayout from '@/Pages/Projects/Edit';
import Panel from "@/Components/Panel";
import Table from "@/Components/Table";
import Input from "@/Components/Input";
import TableButton from "@/Components/TableButton";
import DeleteDialog from "@/Components/DeleteDialog";
import {CheckIcon, PlusIcon, XIcon} from "@heroicons/vue/outline";
import Heading from "@/Components/Heading";
import Pagination from "@/Components/Pagination.vue";

export default {
    components: {
        Pagination,
        Heading,
        CheckIcon,
        DeleteDialog,
        TableButton,
        Input,
        Table,
        Panel,
        PlusIcon,
        ExtendedLayout,
        XIcon,
    },
    props: {
        project: Object,
        paginator: Object,
        feedOptions: Object,
    },
    data() {
        return {
            deleting: null,
        }
    },
}
</script>
